// PostgreSQL Schema Compiler
// -------
var inherits = require('inherits');

var SchemaCompiler = require('../../../schema/compiler');

function SchemaCompiler_PG() {
  SchemaCompiler.apply(this, arguments);
}

inherits(SchemaCompiler_PG, SchemaCompiler); // Check whether the current table

SchemaCompiler_PG.prototype.hasTable = function (tableName) {
  var sql = 'select * from information_schema.tables where table_name = ?';
  var bindings = [tableName];

  if (this.schema) {
    sql += ' and table_schema = ?';
    bindings.push(this.schema);
  } else {
    sql += ' and table_schema = current_schema()';
  }

  this.pushQuery({
    sql: sql,
    bindings: bindings,
    output: function output(resp) {
      return resp.rows.length > 0;
    }
  });
}; // Compile the query to determine if a column exists in a table.


SchemaCompiler_PG.prototype.hasColumn = function (tableName, columnName) {
  var sql = 'select * from information_schema.columns where table_name = ? and column_name = ?';
  var bindings = [tableName, columnName];

  if (this.schema) {
    sql += ' and table_schema = ?';
    bindings.push(this.schema);
  } else {
    sql += ' and table_schema = current_schema()';
  }

  this.pushQuery({
    sql: sql,
    bindings: bindings,
    output: function output(resp) {
      return resp.rows.length > 0;
    }
  });
};

SchemaCompiler_PG.prototype.qualifiedTableName = function (tableName) {
  var name = this.schema ? "".concat(this.schema, ".").concat(tableName) : tableName;
  return this.formatter.wrap(name);
}; // Compile a rename table command.


SchemaCompiler_PG.prototype.renameTable = function (from, to) {
  this.pushQuery("alter table ".concat(this.qualifiedTableName(from), " rename to ").concat(this.formatter.wrap(to)));
};

SchemaCompiler_PG.prototype.createSchema = function (schemaName) {
  this.pushQuery("create schema ".concat(this.formatter.wrap(schemaName)));
};

SchemaCompiler_PG.prototype.createSchemaIfNotExists = function (schemaName) {
  this.pushQuery("create schema if not exists ".concat(this.formatter.wrap(schemaName)));
};

SchemaCompiler_PG.prototype.dropSchema = function (schemaName) {
  this.pushQuery("drop schema ".concat(this.formatter.wrap(schemaName)));
};

SchemaCompiler_PG.prototype.dropSchemaIfExists = function (schemaName) {
  this.pushQuery("drop schema if exists ".concat(this.formatter.wrap(schemaName)));
};

SchemaCompiler_PG.prototype.dropExtension = function (extensionName) {
  this.pushQuery("drop extension ".concat(this.formatter.wrap(extensionName)));
};

SchemaCompiler_PG.prototype.dropExtensionIfExists = function (extensionName) {
  this.pushQuery("drop extension if exists ".concat(this.formatter.wrap(extensionName)));
};

SchemaCompiler_PG.prototype.createExtension = function (extensionName) {
  this.pushQuery("create extension ".concat(this.formatter.wrap(extensionName)));
};

SchemaCompiler_PG.prototype.createExtensionIfNotExists = function (extensionName) {
  this.pushQuery("create extension if not exists ".concat(this.formatter.wrap(extensionName)));
};

module.exports = SchemaCompiler_PG;